// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { SystemDetailsModel } from 'src/app/api/remote-api/.portal.generated/models';
import {
  COOLING_SYSTEM_COMPONENT_ID,
  CT_NAEOTOM_ALPHA_MATERIAL_NUMBERS,
} from 'src/app/constants/portal-cooling-companion/cooling-companion';
import { DeepReadonly } from '../../shared/utils/api-call-state.util';
import { CT_MODALITY_ID } from '../../shared/utils/modalityHelpers';

@Injectable({
  providedIn: 'root',
})
export class CoolingSystemComponentService {
  constructor() {}

  checkIfCoolingSystemComponentIsOfCtNaeotomAlpha(
    componentId: number | undefined,
    systemDetails: DeepReadonly<SystemDetailsModel>,
  ): boolean {
    return (
      componentId === COOLING_SYSTEM_COMPONENT_ID &&
      systemDetails.modalityId === CT_MODALITY_ID &&
      CT_NAEOTOM_ALPHA_MATERIAL_NUMBERS.includes(
        systemDetails.systemMaterialNumber,
      )
    );
  }
}
